import React from "react";
import { Row, Col, Card } from "antd";
import { useTranslation } from "react-i18next";
import CampaignCardNew from "./CampaignCardNew";
import ProposalCard from "./ProposalCard";

const LOADER_KEYS = [1, 2, 3, 4, 5, 6];

const CampaignsGrid = ({
  campaigns,
  loading,
  viewMode,
  state,
  statusLabel,
  variant,
  onDetail,
  onEdit,
  onDelete,
  onArchive,
}) => {
  const { t } = useTranslation();
  const CardComponent = variant === "proposals" ? ProposalCard : CampaignCardNew;

  if (loading) {
    return (
      <Row type="flex" gutter={16}>
        {LOADER_KEYS.map((i) => (
          <Col key={i} xs={24} sm={24} md={12} lg={8} xl={8}>
            <Card loading style={{ marginBottom: 16, padding: 20 }} />
          </Col>
        ))}
      </Row>
    );
  }

  if (!campaigns.length) {
    return <div className="campaignsManager__empty">{t("No campaigns")}</div>;
  }

  const colProps =
    viewMode === "list"
      ? { xs: 24 }
      : { xs: 24, sm: 24, md: 12, lg: 8, xl: 8 };

  return (
    <Row type="flex" gutter={16}>
      {campaigns.map((campaign) => (
        <Col key={campaign.id} {...colProps} style={{ marginBottom: 16 }}>
          <CardComponent
            campaign={campaign}
            state={state}
            statusLabel={statusLabel}
            viewMode={viewMode}
            onDetail={() => onDetail && onDetail(campaign)}
            onEdit={() => onEdit && onEdit(campaign)}
            onDelete={() => onDelete && onDelete(campaign)}
            onArchive={() => onArchive && onArchive(campaign)}
          />
        </Col>
      ))}
    </Row>
  );
};

export default CampaignsGrid;
